import { WebPushPreviewContextProvider } from './WebPushPreviewContextProvider';

export const WebPushContext = ({ children }: { children: React.ReactNode }) => (
  <WebPushPreviewContextProvider>{children}</WebPushPreviewContextProvider>
);
